export default __webpack_public_path__ + "static/media/icon_email.42cf9a15.svg";